export default "__VITE_ASSET__CT80XhKp__"